import axios from "axios"
import baseURL from "../configs/api"

export const post_VehicleMaintenanceRule = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleMaintenanceRules?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_VehicleMaintenanceRule = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleMaintenanceRules?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_VehicleMaintenanceRule = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleMaintenanceRules`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: { id: id, userId: userId }
    }).then(response => response.data);
}

export const getVehicleMaintenanceRuleReportPaging = (page: number, size: number, tenantId: string) => {
    return getFetch(`vehicleMaintenanceRules/GetVehicleMaintenanceRuleReportPaging/${page},${size}`, tenantId);
}

export const getVehicleMaintenanceRuleReportPagingBySearchWithVehicleClassName = (vehicleClassName: string, page: number, size: number, tenantId: string) => {
    return getFetch(`vehicleMaintenanceRules/GetVehicleMaintenanceRuleReportPagingBySearchWithVehicleClassName/?vehicleClassName=${vehicleClassName}&page=${page}&size=${size}`, tenantId);
}

export const getVehicleMaintenanceRuleReportPagingBySearchWithMaintenanceTypeName = (maintenanceTypeName: string, page: number, size: number, tenantId: string) => {
    return getFetch(`vehicleMaintenanceRules/GetVehicleMaintenanceRuleReportPagingBySearchWithMaintenanceTypeName/?maintenanceTypeName=${maintenanceTypeName}&page=${page}&size=${size}`, tenantId);
}

export const getVehicleMaintenanceRules = (tenantId: string) => {
    return getFetch(`vehicleMaintenanceRules`, tenantId);
}

export const getVehicleMaintenanceRule = (primaryKey: number, tenantId: string) => {
    return getFetch(`VehicleMaintenanceRules/${primaryKey}`, tenantId);
}


const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}